import type { RouteComponentProps } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IonContent, IonPage, IonText, IonHeader, IonIcon } from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import Network from "src/api/network";
import { useQuery } from "react-query";

const Other: React.FC<RouteComponentProps> = ({ history }) => {
  const { t } = useTranslation();
  const { data: other } = useQuery(["other"], () => Network.all());

  if (!other) return null;

  return (
    <IonPage>
      <IonHeader className="bg-header text-white shadow-none flex items-center justify-between ">
        <div className="p-2 pb-0 text-white" onClick={() => history.goBack()}>
          <IonIcon icon={chevronBackOutline} size="large" />
        </div>
        <IonText className="font-medium text-lg">{t("team.other")}</IonText>
        <div className="w-8"></div>
      </IonHeader>
      <IonContent fullscreen>
        {other.length > 0 ? (
          <div></div>
        ) : (
          <IonText>{t("network.no_team_members")}</IonText>
        )}
      </IonContent>
    </IonPage>
  );
};

export default Other;
